import { receivedFeatureFlags } from "../featureFlagsSlice";
import { getFeatureFlagValue, getFeatureFlagVersion, } from "../../../utils/typeUtils";
import { isNil, omitBy } from "lodash";
import getSplitClient from "../getSplitClient";
import { updateConfiguration } from "../../configuration/configurationSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useEffect } from "react";
export default function useInitFeatureFlags() {
    var _a = useAppSelector(function (state) { return state.configuration; }), userId = _a.userId, utmSource = _a.utmSource, isSavvyAgent = _a.isSavvyAgent, experience = _a.experience;
    var dispatch = useAppDispatch();
    useEffect(function () {
        var client = getSplitClient(userId);
        client.on(client.Event.SDK_READY, function () {
            var affiliateId = utmSource !== null && utmSource !== void 0 ? utmSource : "";
            /**
             * Request this flag first as other flag depend on it's value
             */
            var onboard_connect_frontend = getFeatureFlagValue(client.getTreatment("onboard_connect_frontend", {
                affiliateId: affiliateId,
                experience: experience !== null && experience !== void 0 ? experience : "",
            }));
            var flags = omitBy({
                unlinkedApplication_vehicleVINEntry_frontend: getFeatureFlagValue(client.getTreatment("unlinkedApplication_vehicleVINEntry_frontend", {
                    isSavvyAgent: isSavvyAgent,
                })),
                onboard_connect_frontend: onboard_connect_frontend,
                unlinkedApplication_premiumEnabled_frontend: getFeatureFlagValue(client.getTreatment("unlinkedApplication_premiumEnabled_frontend", {
                    isSavvyAgent: isSavvyAgent,
                })),
                unlinkedApplication_issuerPageFirst_frontend: getFeatureFlagValue(client.getTreatment("unlinkedApplication_issuerPageFirst_frontend", {
                    affiliateId: affiliateId,
                    experience: experience !== null && experience !== void 0 ? experience : "",
                })),
                recommend_editPolicy_frontend: getFeatureFlagValue(client.getTreatment("recommend_editPolicy_frontend", {
                    experience: experience !== null && experience !== void 0 ? experience : "",
                })),
                recommend_leaveBehindSearch_frontend: getFeatureFlagVersion(client.getTreatment("recommend_leaveBehindSearch_frontend")),
            }, isNil);
            var originalDisabledIssuersFromSplit = client.getTreatmentWithConfig("connect_disabledIssuers_frontend");
            var disabledIssuersFromSplit = JSON.parse(originalDisabledIssuersFromSplit.config || "");
            if (disabledIssuersFromSplit.length > 0) {
                dispatch(updateConfiguration({
                    disabledIssuers: disabledIssuersFromSplit,
                }));
            }
            dispatch(receivedFeatureFlags(flags));
        });
    }, []); // eslint-disable-line
}
